// Money formatting — one place so a price never renders as "₹NaN" or "₹2.0".
export function formatMoney(amount, currency = "INR") {
  const n = Number(amount);
  const safe = Number.isFinite(n) ? n : 0;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency || "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(safe);
  } catch {
    return "₹" + safe.toFixed(2);
  }
}
